import React from 'react';
import { Link } from 'react-router-dom';
import { CloudSunIcon, MapIcon, PhoneIcon, StarIcon, InfoIcon, SettingsIcon } from 'lucide-react';
import Header from '../components/Header';
const More = () => {
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-536">
      <Header title="Meer" data-id="element-537" />
      <div className="p-4" data-id="element-538">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-4" data-id="element-539">
          <MenuItem to="/maintenance" icon={<div size={20} className="text-[#f9b30f]" data-id="element-541" />} label="Onderhoudsmelding" data-id="element-540" />
          <MenuItem to="/weather" icon={<CloudSunIcon size={20} className="text-[#f9b30f]" data-id="element-543" />} label="Weer & Tips" data-id="element-542" />
          <MenuItem to="/map" icon={<MapIcon size={20} className="text-[#f9b30f]" data-id="element-545" />} label="Plattegrond & Navigatie" data-id="element-544" />
          <MenuItem to="/contact" icon={<PhoneIcon size={20} className="text-[#f9b30f]" data-id="element-547" />} label="Contact & Noodgevallen" data-id="element-546" />
          <MenuItem to="/feedback" icon={<StarIcon size={20} className="text-[#f9b30f]" data-id="element-549" />} label="Feedback & Reviews" data-id="element-548" />
        </div>
        <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-550">
          <MenuItem to="#" icon={<InfoIcon size={20} className="text-[#f9b30f]" data-id="element-552" />} label="Over Camping Olympia" data-id="element-551" />
          <MenuItem to="#" icon={<SettingsIcon size={20} className="text-[#f9b30f]" data-id="element-554" />} label="Instellingen" data-id="element-553" />
        </div>
        <div className="mt-8 text-center" data-id="element-555">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kHbcTFuL12xcnB5vGryAMD/logo.png" alt="Camping Olympia" className="h-16 mx-auto mb-2" data-id="element-556" />
          <p className="text-sm text-gray-500" data-id="element-557">Camping Olympia Group</p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-558">Versie 1.0.0</p>
        </div>
      </div>
    </div>;
};
const MenuItem = ({
  to,
  icon,
  label
}) => {
  return <Link to={to} className="flex items-center p-4 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-559">
      <div className="mr-3" data-id="element-560">{icon}</div>
      <span data-id="element-561">{label}</span>
    </Link>;
};
export default More;